import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Dil dosyalarını import et
import enTranslation from './locales/en/translation.json';
import trTranslation from './locales/tr/translation.json';
import esTranslation from './locales/es/translation.json';

/** Navbar’da seçilen dil; sayfa yenilendiğinde buradan okunur */
export const I18N_LANGUAGE_KEY = 'i18nLanguage';

const UI_LANGUAGES = ['en', 'tr', 'es', 'de', 'pt'];

function getInitialLanguage() {
  try {
    const stored = localStorage.getItem(I18N_LANGUAGE_KEY);
    if (stored && UI_LANGUAGES.includes(stored)) {
      return stored;
    }
  } catch (_) {
    // private / disabled storage
  }
  return 'en';
}

const resources = {
  en: {
    translation: enTranslation
  },
  tr: {
    translation: trTranslation
  },
  es: {
    translation: esTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
